import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { db } from "../firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import "./StatutoryWarning.css"; // Changed to new general CSS
import { AuthContext } from "../context/AuthContext";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function StatutoryWarningDetail() { // Renamed component
    const { id } = useParams();
    const [statutoryWarning, setStatutoryWarning] = useState(null); // Renamed state
    const [loading, setLoading] = useState(true);
    const [editing, setEditing] = useState(false);
    const [editTitle, setEditTitle] = useState("");
    const [editContent, setEditContent] = useState("");
    const [editImageUrl, setEditImageUrl] = useState("");
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");
    const { user } = useContext(AuthContext);

    useEffect(() => {
        async function fetchStatutoryWarning() { // Renamed function
            setLoading(true);
            const docRef = doc(db, "statutory-warnings", id); // Changed collection
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                setStatutoryWarning({ id: docSnap.id, ...docSnap.data() }); // Renamed state
            }
            setLoading(false);
        }
        fetchStatutoryWarning(); // Renamed function
    }, [id]);

    const startEditing = () => {
        setEditTitle(statutoryWarning.title || "");
        setEditContent(statutoryWarning.content || "");
        setEditImageUrl(statutoryWarning.imageUrl || "");
        setEditing(true);
        setError("");
    };

    const handleSave = async (e) => {
        e.preventDefault();
        setSaving(true);
        setError("");
        try {
            const docRef = doc(db, "statutory-warnings", id); // Changed collection
            await updateDoc(docRef, {
                title: editTitle,
                content: editContent,
                imageUrl: editImageUrl
            });
            setStatutoryWarning({ ...statutoryWarning, title: editTitle, content: editContent, imageUrl: editImageUrl }); // Renamed state
            setEditing(false);
        } catch (err) {
            setError("Failed to save: " + err.message);
        }
        setSaving(false);
    };

    if (loading) return <div className="statutory-warning-container"><p>Loading...</p></div>;
    if (!statutoryWarning) return <div className="statutory-warning-container"><p>Statutory warning not found.</p></div>; // Changed text

    return (
        <div className="statutory-warning-container"> {/* Renamed class */}
            {user && (
                <button className="button" style={{ marginBottom: 16 }} onClick={startEditing}>Edit</button>
            )}
            {editing ? (
                <form onSubmit={handleSave} style={{ marginBottom: 16 }}>
                    <input type="text" value={editTitle} onChange={e => setEditTitle(e.target.value)} placeholder="Title" style={{ width: "100%", marginBottom: 8, padding: "10px", border: " 1px solid #ccc", borderRadius: "4px" }} />
                    <div style={{ marginBottom: "40px" }}>
                        <ReactQuill
                            value={editContent}
                            onChange={setEditContent}
                            style={{ height: "300px", marginBottom: "60px" }}
                        />
                        <input type="url" value={editImageUrl} onChange={e => setEditImageUrl(e.target.value)} placeholder="Image URL" style={{ width: "100%", marginBottom: 8, padding: "10px", border: " 1px solid #ccc", borderRadius: "4px" }} />
                    </div>
                    <button type="submit" className="button" disabled={saving}>{saving ? "Saving..." : "Save"}</button>
                    <button type="button" className="button" style={{ marginLeft: 8, background: "#888" }} onClick={() => setEditing(false)}>Cancel</button>
                    {error && <p style={{ color: "red" }}>{error}</p>}
                </form>
            ) : (
                <>
                    <br />
                    <img src={statutoryWarning.imageUrl || "https://via.placeholder.com/120"} alt="statutory warning" style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: 8, marginBottom: 16 }} />
                    <h2>{statutoryWarning.title}</h2>
                    <div style={{ fontSize: 12, color: "#888", marginTop: 4 }}>
                        {statutoryWarning.date && statutoryWarning.date.seconds ? new Date(statutoryWarning.date.seconds * 1000).toLocaleString() : ""}
                    </div>
                    <div style={{ marginBottom: 8, color: "#555" }}>
                        <div dangerouslySetInnerHTML={{ __html: statutoryWarning.content }} />
                    </div>
                </>
            )}
        </div>
    );
}

export default StatutoryWarningDetail; // Renamed export